var History = {
  create: function create() {
    return {
      undos: [],
      redos: []
    };
  }
};
export default History;